import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news71Img from "../../images/news/news7_1.png";
import news72Img from "../../images/news/news7_2.png";
import news73Img from "../../images/news/news7_3.png";
import news74Img from "../../images/news/news7_4.png";

import { withTranslation } from "react-i18next";

	
class news7 extends Component {
	componentDidMount() {
		
	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News7_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News7_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News7_LinkHome")}</Link>
								</li>
								<li>{t("News7_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
										<h1>{t("News7_Content_H")}</h1>
											<p>{t("News7_Content_P2")}</p>
											<p>{t("News7_Content_P3")}</p>	
											<p style={{ textAlign: "center" }}><img alt="" src={news71Img} /></p>										
											<p>{t("News7_Content_P4")}</p>
											<p>{t("News7_Content_P5")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news72Img} /></p>
											<p>{t("News7_Content_P6")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news73Img} /></p>
											<p>{t("News7_Content_P14")}</p>
											<p>{t("News7_Content_P7")}</p>
											<strong>Louis</strong><p>{t("News7_Content_P8")}</p>
											<strong>Qi Wu</strong><p>{t("News7_Content_P9")}</p>
											<strong>Kerrilee Lockyer</strong><p>{t("News7_Content_P10")}</p>
											<strong>Savitha Sam Abraham</strong><p>{t("News7_Content_P11")}</p>
											<strong>Zerui Li</strong><p>{t("News7_Content_P12")}</p>
											<p style={{ textAlign: "center" }}><img alt="" src={news74Img} /></p>
											<p>{t("News7_Content_P15")}</p>
											<p>{t("News7_Content_P16")}</p>
											<p>{t("News7_Content_P17")}</p>
											<p>{t("News7_Content_P18")}</p>
											<p>{t("News7_Content_P19")}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news7 = withTranslation()(news7);
